import { PRODUCT_CATEGORY, PRODUCT_TYPES } from '@schuettflix/interfaces';
import { productTypeToProductCategoryMap } from './constants/productTypeToProductCategoryMap.ts';

export function getProductCategoryByProductType(productType: PRODUCT_TYPES): PRODUCT_CATEGORY {
    return productTypeToProductCategoryMap[productType];
}
